module.exports = __webpack_public_path__ + "static/media/billable-expense-income.29d0f6e5.svg";